import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import FilterInput from "components/Form/filterInput"
const EmployeeListFilter = () => {
  const employee = [
    { value: 1, label: "John Deo" },
    { value: 2, label: "Richard Miles" },
    { value: 3, label: "John Smith" },
  ];
  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: 40,
      fontSize:12
    }),
    option: (provided, state) => ({
      
      ...provided,
      backgroundColor: state.isFocused ? "#D3001A" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#D3001A",
      },
    }),
  };
  const [inputValue, setInputValue] = useState("");
  const [inputValue1, setInputValue1] = useState("");
  const [focused, setFocused] = useState(false);
  const [focused1, setFocused1] = useState(false);

  const handleLabelClick = () => {
    setFocused(true);
  };

  const handleLabelClick2 = () => {
    setFocused1(true);
  };

  const handleInputBlur = () => {
    if (inputValue === "") {
      setFocused(false);
    }
  };

  const handleInputBlur2 = () => {
    if (inputValue1 === "") {
      setFocused1(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (value !== "" && !focused) {
      setFocused(true);
    }
  };

  const handleInputChange2 = (e) => {
    const value = e.target.value;
    setInputValue1(value);
    if (value !== "" && !focused1) {
      setFocused1(true);
    }
  };

  return (
    <div>
      <div className="row filter-row mb-4">
        <div className="col-sm-6 col-md-10 col-lg-11">

      
        </div>
      
 
        <div className="col-lg-1 col-md-2 col-sm-6 d-flex justify-content-end">
       
            <button   className={`list-view btn btn-link active`}>
              <i className="fa fa-filter" />
            </button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeListFilter;
